import { z } from "zod";
import type { WidgetModule, WidgetRenderContext } from "@salestrak/ui";
import { CommentsWidgetBody } from "#app/widgets/summary/comments-widget-body";
import { useIssueWidgetContext } from "#app/widgets/issue/issue-widget-context";

export const issueCommentsConfigSchema = z.looseObject({ limit: z.number().default(3) });
export type IssueCommentsConfig = z.infer<typeof issueCommentsConfigSchema>;

function IssueCommentsRender({ config }: WidgetRenderContext<IssueCommentsConfig>) {
  const ctx = useIssueWidgetContext();
  return (
    <CommentsWidgetBody
      entityId={ctx.issue?.issueId}
      activity={ctx.activity}
      activityLoading={ctx.activityLoading}
      notes={ctx.notes}
      limit={config.limit}
    />
  );
}

export const issueCommentsDef: WidgetModule<IssueCommentsConfig> = {
  type: "issue-comments",
  title: "Comments",
  icon: "message",
  span: { minW: 3, minH: 2, maxW: 12, maxH: 12, defaultW: 12, defaultH: 4 },
  configSchema: issueCommentsConfigSchema,
  render: IssueCommentsRender,
};
